import { Modal as AntdModal, Button, ButtonProps, ModalProps, ConfigProvider } from 'antd';
import { HTMLAttributes } from 'react';
import './app-modal.style.css';
import clsx from 'clsx';

const AppModal = (props: ModalProps) => (
  <ConfigProvider
    theme={{
      components: {
        Modal: {
          headerBg: 'var(--color-white)',
          contentBg: 'var(--color-white)',
          footerBg: 'var(--color-white)',
          borderRadius: 8,
          padding: 24,
        },
      },
    }}
  >
    <AntdModal className="appModal" centered {...props} />
  </ConfigProvider>
);

const ModalHeader = (props: HTMLAttributes<HTMLDivElement>) => {
  const { className, ...restProps } = props;
  return <div className={clsx('appModal__header', className)} {...restProps} />;
};

const ModalTitle = (props: HTMLAttributes<HTMLDivElement>) => {
  const { className, children, ...restProps } = props;
  return (
    <div className={clsx('text-text-900 text-xl leading-6.25 mb-2 font-medium', className)} {...restProps}>
      {children}
    </div>
  );
};

const ModalSubTitle = (props: HTMLAttributes<HTMLDivElement>) => {
  const { className, children, ...restProps } = props;
  return (
    <div className={clsx('text-text-500 text-sm leading-3.75 font-medium mb-6', className)} {...restProps}>
      {children}
    </div>
  );
};

const ModalBody = (props: HTMLAttributes<HTMLDivElement>) => {
  const { className, children, ...restProps } = props;
  return (
    <div className={clsx('appModal__body', className)} {...restProps}>
      {children}
    </div>
  );
};

const ModalFooter = (props: HTMLAttributes<HTMLDivElement>) => {
  const { className, children, ...restProps } = props;
  return (
    <div className={clsx('appModal__footer flex gap-4 justify-end', className)} {...restProps}>
      {children}
    </div>
  );
};

const ModalButton = (props: ButtonProps) => {
  const { children, ...restProps } = props;
  return (
    <Button variant="solid" {...restProps}>
      {children}
    </Button>
  );
};

AppModal.Header = ModalHeader;
AppModal.Title = ModalTitle;
AppModal.SubTitle = ModalSubTitle;
AppModal.Body = ModalBody;
AppModal.Footer = ModalFooter;
AppModal.Button = ModalButton;

export { AppModal };
